import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { WareHouse } from 'shared/utils/validation/AuthValidation';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { AddWareHousesMutation, UpdateWareHousesMutation } from 'shared/services/ware_house_service/WareHouseService';

export default function WareHouseAdd({ show, datatable, handleClose, isEdit = false, editData = null }) {
    const { mutate: addCWareHouseMutation, isLoading: BrandLoading, isSuccess: BrandIsSuccess } = AddWareHousesMutation();
    const { mutate: updateWareHouseMutation, isLoading: UpdateWarehouseLoading, isSuccess: UpdateWarehouseIsSuccess } = UpdateWareHousesMutation();
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const initialValues = {
        name: isEdit && editData?.name ? editData.name : '',
        location: isEdit && editData?.location ? editData.location : '',
        code: isEdit && editData?.code ? editData.code : '',
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: WareHouse,
        onSubmit: (values) => {
            brandHandler(values);
        }
    });
    const { handleChange, handleSubmit, values, touched, errors } = formik;

    const brandHandler = (values) => {
        if (isEdit && editData?._id) {
            updateWareHouseMutation({
                id: editData._id,
                payload: {
                    name: values.name,
                    location: values.location,
                    code: values.code
                }
            });
        } else {
            addCWareHouseMutation({
                name: values.name,
                location: values.location,
                code: values.code
            });
        }
    };

    useEffect(() => {
        if ((BrandIsSuccess || UpdateWarehouseIsSuccess) && show) {
            formik.resetForm();
            handleClose();
        }
    }, [BrandIsSuccess, UpdateWarehouseIsSuccess]);

    return (
        <Modal show={show} onHide={handleClose} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className={styles.Header}>
                <Heading heading={isEdit ? 'Edit Warehouse' : 'Add Warehouse'} headingStyle={styles.AddLinkHeading} />
            </Modal.Header>
            <Modal.Body className={classNames(`${theme}ModalBackground`, styles.Body)}>
                <div className={classNames(styles.AddLinkContainer)}>
                    <CustomInput
                        label={isEdit ? 'Edit Warehouse Name' : 'Warehouse Name'}
                        placeholder={'Shop1'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.name}
                        onChange={handleChange('name')}
                        error={errors.name && touched.name ? errors.name : ''}
                    />
                    <CustomInput
                        label={'Location'}
                        placeholder={'Country || City'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.location}
                        onChange={handleChange('location')}
                        error={errors.location && touched.location ? errors.location : ''}
                    />
                    <CustomInput
                        label={'Code'}
                        placeholder={'HX-M4'}
                        CustomInputStyle={classNames(`${theme}ItemBackground`, styles.CustomInputStyle)}
                        CustomLabelStyle={styles.CustomLabelStyle}
                        InputContainerStyle={styles.InputContainerStyle}
                        value={values.code}
                        onChange={handleChange('code')}
                        error={errors.code && touched.code ? errors.code : ''}
                    />

                    <div className="d-flex justify-content-end">
                        <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={handleClose} />
                        <CustomButton text={isEdit ? 'Update' : 'Add'} containerStyle={styles.SubmitBtn} submitHandle={handleSubmit} />
                    </div>
                </div>
                {(BrandLoading || UpdateWarehouseLoading) && <OverlayLoading />}
            </Modal.Body>
        </Modal>
    );
}
